import { useEffect, useState } from 'react'
import { Container } from './styles'
import linkedin from '../../assets/linkedin.svg'
import githubIcon from '../../assets/github.svg'
import Resume from '../../assets/MeherSultana.pdf'

const highlightTerms = [
  'AI-assisted analytics',
  'business intelligence',
  'LLM-powered workflows',
  'data storytelling',
]

export function Hero() {
  const [termIndex, setTermIndex] = useState(0)
  const [displayed, setDisplayed] = useState('')
  const [isDeleting, setIsDeleting] = useState(false)

  useEffect(() => {
    const current = highlightTerms[termIndex]
    const isComplete = displayed === current
    const isEmpty = displayed.length === 0

    const nextDelay =
      !isDeleting && isComplete
        ? 900
        : isDeleting && isEmpty
        ? 180
        : isDeleting
        ? 55
        : 85

    const timeout = setTimeout(() => {
      if (!isDeleting && !isComplete) {
        setDisplayed(current.slice(0, displayed.length + 1))
      } else if (!isDeleting && isComplete) {
        setIsDeleting(true)
      } else if (isDeleting && !isEmpty) {
        setDisplayed(current.slice(0, displayed.length - 1))
      } else if (isDeleting && isEmpty) {
        setIsDeleting(false)
        setTermIndex((prev) => (prev + 1) % highlightTerms.length)
      }
    }, nextDelay)

    return () => clearTimeout(timeout)
  }, [displayed, isDeleting, termIndex])

  return (
    <Container id="home">
      <p className="eyebrow">Data &amp; AI Analyst</p>
      <div className="name">
        <span>Meher</span>
        <span>Sultana</span>
      </div>

      <div className="animated-line" aria-live="polite">
        <span className="ai-tag">Data x</span>
        <span className="typing">{displayed}</span>
        <span className="cursor">|</span>
      </div>

      <p className="lede">
        Data analyst with 3+ years translating complex datasets into clear, actionable strategy. I blend AI/ML,
        cloud, and visualization to build decision-ready products that move teams forward.
      </p>

      <div className="actions">
        <a className="button" href="#project">
          View projects
        </a>
        <a className="ghost" href="#contact">
          Work together
        </a>
        <a className="ghost" href={Resume} download>
          Download resume
        </a>
      </div>

      <div className="social-links" aria-label="Social links">
        <a
          href="https://www.linkedin.com/in/meher-s-r46/"
          target="_blank"
          rel="noreferrer"
          aria-label="LinkedIn"
        >
          <img src={linkedin} alt="" />
        </a>
        <a href="https://github.com/MeherSultana" target="_blank" rel="noreferrer" aria-label="GitHub">
          <img src={githubIcon} alt="" />
        </a>
      </div>
    </Container>
  )
}
